export const data = {
  transactionReport: {
    title: 'Transaction Report',
    summary: 'Summary of all your transactional activities',
  },
  commissionReport: {
    title: 'Commission Report',
    summary: 'Summary of your commission earning',
  },
  gstCommissionInvoice: {
    title: 'Download GST Commission Invoice',
    summary: 'GST at 18% is applicable to all taxable value of supply provided by an agent.',
  },
  submitGSTInput: {
    title: 'Submit GST Input',
    summary: 'GST at 18% is applicable to all taxable value of supply provided by an agent.',
  },
  trackGSTInputCredit: {
    title: 'Track GST Input Credit',
    summary: 'GST at 18% is applicable to all taxable value of supply provided by an agent.',
  },
};
